<template>
  <v-text-field
    v-model="proxyValue"
    type="number"
    :label="label"
    :rules="[amountRules, ...additionalRules]"
    required>
    <template slot="append">
      {{currencySign}}
    </template>
  </v-text-field>
</template>

<script>
    import {isNumeric} from '../../helpers/types'

    // todo(egor): integrate with vue forms
    // todo(egor): restrict input more than 2 numbers after dot
    export default {
        name: 'amount-input',
        props: {
            value: {
                type: Number,
            },
            label: {
                type: String
            },
            currency: {
                type: String,
                default: 'RUB'
            },
            nullable: {
                type: Boolean,
                default: false
            },
            additionalRules: {
                type: Array, // vuetify rules
                default: []
            }
        },
        data() {
            return {}
        },
        computed: {
            proxyValue: {
                get() {
                    return this.value
                },
                set(newValue) {
                    if (newValue === '') {
                        this.$emit('input', null)
                        return
                    }

                    if (!isNumeric(newValue)) {
                        this.$emit('input', null)
                        return
                    }

                    let numericPrice = parseFloat(newValue) // trim decimals

                    this.$emit('input', numericPrice)
                }
            },
            currencySign() {
                if (this.currency === 'RUB') {
                    return '₽'
                }

                if (this.currency === 'USD') {
                    return '$'
                }

                return this.currency
            },
            decimalPlace() {
                return 2 // currency specific
            }
        },
        methods: {
            amountRules(value) {
                if (this.nullable && !value) {
                    return true
                }

                // todo(TECH-325): accept null
                let numeric = isNumeric(value)

                if (!numeric) {
                    return 'Must be numeric value'
                }

                return true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Ui/AmountInput.vue